import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterTransmissionTypeIdSearchValueObject extends ValueObject {
  #transmissionTypeId

  constructor({transmissionTypeId}) {
    super()
    this.#transmissionTypeId = transmissionTypeId
  }

  static create({transmissionTypeId}) {
    return new FilterTransmissionTypeIdSearchValueObject({
      transmissionTypeId: FilterIdSearchValueObject.create(transmissionTypeId)
    })
  }

  static createWithDefaultValue({config, transmissionTypeId}) {
    const {DEFAULT_TRANSMISSION_TYPE_ID_SEARCH} = config.get('searchFilters')

    return new FilterTransmissionTypeIdSearchValueObject({
      transmissionTypeId: FilterIdSearchValueObject.create({
        id: transmissionTypeId ?? DEFAULT_TRANSMISSION_TYPE_ID_SEARCH
      })
    })
  }

  static createQueryParams({config, transmissionTypeId}) {
    const {DEFAULT_TRANSMISSION_TYPE_ID_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterTransmissionTypeIdSearchValueObject({
      transmissionTypeId: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.TRANSMISSION_TYPE],
        value: transmissionTypeId === DEFAULT_TRANSMISSION_TYPE_ID_SEARCH ? null : transmissionTypeId
      })
    })
  }

  get isEmpty() {
    return this.#transmissionTypeId.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#transmissionTypeId.queryParam})
    }
  }

  get value() {
    return this.#transmissionTypeId.value
  }

  toJSON() {
    return {
      transmissionTypeId: this.#transmissionTypeId.toJSON()
    }
  }
}
